import {Dispatcher} from '@discordapp/flux';

import type {Action} from './flow/Action';

export {Dispatcher};
export default new Dispatcher() as Dispatcher<Action>;
